import React from "react"
import { BaseLayout, ImageFrame, SEO } from "../components"
import { langId } from "../languages"
import classnames from "classnames"

const ImageFrameForHome = ({ frameConfig, noTitleSpace }) => {
  return (
    <ImageFrame
      title={frameConfig.title}
      fluidImg={frameConfig.img.childImageSharp.fluid}
      baseSlug={frameConfig.baseSlug}
      baseSlug4Title={frameConfig.key === "STORY1" && "link-feature-stories"}
      date={frameConfig.date}
      subtitle={frameConfig.subtitle}
      imgAlt={frameConfig.imgAlt}
      imgTitle={frameConfig.imgTitle}
      isCoverImg={frameConfig.key === "COVER" && "link-feature-stories"}
      noTitleSpace={noTitleSpace}
    ></ImageFrame>
  )
}

const HomeTemplate = props => {
  // home page baseSlug is dtfferent from the other
  // base slug will be lang key
  const {
    imageframeConfig,
    title,
    description,
    keywords,
    ogImage,
  } = props.data.mdx.frontmatter
  // console.log("HomeTemplate", props)
  return (
    <BaseLayout lang={props.pageContext.baseSlug} baseSlug={""}>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        uriPath={props.uri}
        lang={props.pageContext.baseSlug}
        baseSlug={""}
        ogImage={ogImage}
      ></SEO>
      <div className="home-template">
        <div className="home-template__col1">
          <ImageFrameForHome
            frameConfig={imageframeConfig[0]}
          ></ImageFrameForHome>
          <ImageFrameForHome
            frameConfig={imageframeConfig[1]}
          ></ImageFrameForHome>
        </div>
        <div className="home-template__col2">
          <ImageFrameForHome
            frameConfig={imageframeConfig[2]}
          ></ImageFrameForHome>
          <ImageFrameForHome
            frameConfig={imageframeConfig[3]}
          ></ImageFrameForHome>
          <ImageFrameForHome
            frameConfig={imageframeConfig[4]}
          ></ImageFrameForHome>
        </div>
        <div
          className={classnames({
            "home-template__col2": true,
            "home-template__col2--sp": true,
          })}
          style={{ justifyContent: "center" }}
        >
          <ImageFrameForHome
            frameConfig={imageframeConfig[5]}
            noTitleSpace
          ></ImageFrameForHome>
          <ImageFrameForHome
            frameConfig={imageframeConfig[6]}
            noTitleSpace
          ></ImageFrameForHome>
          <ImageFrameForHome
            frameConfig={imageframeConfig[7]}
            noTitleSpace
          ></ImageFrameForHome>
        </div>
        <div className="home-template__col3">
          <ImageFrameForHome
            frameConfig={imageframeConfig[8]}
          ></ImageFrameForHome>
          <ImageFrameForHome
            frameConfig={imageframeConfig[9]}
          ></ImageFrameForHome>
          <ImageFrameForHome
            frameConfig={imageframeConfig[10]}
          ></ImageFrameForHome>
        </div>
      </div>
    </BaseLayout>
  )
}

export default HomeTemplate

export const pageQuery = graphql`
  query HomeTemplateQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        ...MdxFrontmatterFragment
        imageframeConfig {
          baseSlug
          date
          key
          subtitle
          title
          imgAlt
          imgTitle
          img {
            ...fragmentsFluidImage
          }
        }
      }
      fields {
        baseSlug
        langKey
        slug
        urlSlug
      }
    }
  }
`
